<template>
  <div class="feature-picker">
    <ul>
      <li v-for="(settings, name) in featureListItems">
        <form class="feature-item">
          <input type="checkbox"
                 :id="name"
                 :disabled="settings.requiresValue && !settings.isEnabled"
                 :checked="settings.isEnabled"
                 @change="onChange(settings, $event)">
          <label :for="name"
                 :uk-tooltip="settings.toolTip">
            {{ name }}
          </label>
          <div class="reload-warning uk-text-warning"
               v-if="settings.forceReload">
            <label>Forces Reload</label>
            <span class="icon" uk-icon="icon: warning; ratio: 1.2"></span>
          </div>
        </form>
      </li>
    </ul>
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'
  import Features from './../../plugins/feature/feature-list'
  import Feature from './../../plugins/feature'
  import {FEATURE_NAMESPACE, SWITCH, SWITCH_AND_VALUE} from './../../plugins/feature/module/types'

  export default {
    name: 'feature-picker',
    computed: {
      ...mapState({
        features: state => state.feature
      }),
      featureListItems() {
        let featureList = {}

        for (let feature in this.features) {
          let featureObj = Features.find(featureObj => featureObj.name === feature)
          featureObj = featureObj || {name: feature, forceReload: false, requiresValue: false, toolTip: ''}
          featureObj.isEnabled = this.features[feature].enabled

          featureList[feature] = featureObj
        }
        return featureList
      }
    },
    methods: {
      ...mapActions(FEATURE_NAMESPACE, {
        updateSwitch: SWITCH,
        updateSwitchAndValue: SWITCH_AND_VALUE
      }),
      onChange(feature, evt) {
        this.updateSwitch({[feature.name]: evt.target.checked})
        this.$router.replace({query: {feature: Feature.featuresToQuery()}})

        if (feature.forceReload) {
          window.location.reload()
        }
      },
      reset(reload = true) {
        let reloadCount = 0
        let self = this

        Object.keys(this.featureListItems).forEach(featureName => {
          if (self.features[featureName]) {
            self.updateSwitchAndValue({
              [featureName]: {
                enabled: false,
                value: null
              }
            })
            if (self.featureListItems[featureName].forceReload) {
              reloadCount++
            }
          }
        })

        if (reload && reloadCount > 0) {
          window.location.reload()
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .feature-picker {
    ul {
      list-style: none;

      li {
        user-select: none;

        .feature-item {
          vertical-align: middle;
          height: 30px;
          padding-top: 10px;

          &:hover {
            background-color: #A5F2A0;
          }

          label {
            cursor: pointer;
          }

          .reload-warning {
            float: right;

            label {
              padding-right: 5px;
            }

            .icon {
              padding-right: 10px;
            }
          }
        }
      }
    }
  }
</style>
